import { COLOR1, COLOR6, WHITE } from '../../constants';

export const BundleErrorModalStyles = {
  backdrop: {
    zIndex: 1301,
    color: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '12px',
  },

  productmodal: {
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
    gap: '8px',
    maxWidth: '420px',
    borderRadius: '24px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
    '@media(max-width:600px)': {
      gap: '12px',
      maxWidth: '272px',
    },
  },

  productmodalcontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '24px',
  },

  errorHead: {
    font: 'normal 700 20px/100% "TTNORMSPROBOLD" !important',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#D5151F',
  },

  errorTitle: {
    font: 'normal 700 24px/100% "TTNORMSPROBOLD" !important',
    letterSpacing: '0px',
    textAlign: 'center',
  },

  errorDescription: {
    font: 'normal 400 16px/18px Arial !important',
    letterSpacing: '0px',
    textAlign: 'center',
  },
};
